// import Cookies from 'js-cookie'

// const TokenKey = 'authToken'

export function getToken() {
  let token = "";
  token =window.localStorage.getItem("token")||window.sessionStorage.getItem("token")||"";
  if (token) {
    token = "Bearer "+token;
  }
  return token
}

export function setToken(token,remember) {
  if (remember) {
    window.localStorage.setItem("token",token);
    window.localStorage.setItem("remember",remember);
  }
  else {
    window.sessionStorage.setItem("token",token);
    window.localStorage.removeItem("remember");
  }
}

export function removeToken() {
  window.localStorage.removeItem("token")
  window.sessionStorage.removeItem("token")
  window.localStorage.removeItem("remember");
  window.localStorage.removeItem("phone");
  window.localStorage.removeItem("name");
  window.localStorage.removeItem("role");
  window.localStorage.removeItem("type");
}
